const ROLES = {
  PLATFORM_ADMIN: 'platform_admin',
  CAMPAIGN_MEMBER: 'campaign_member',
  CAMPAIGN_REVIEWER: 'campaign_reviewer',
  OFF_PLATFORM_SEARCH: 'off_platform_search',
  PLATFORM_REVIEWER: 'platform_reviewer',
  SUPER_ADMIN: 'super_admin',
  ACCOUNTANT_ADMIN: 'accountant_admin',
  MANAGER_ADMIN: 'manager_admin',
  ORGANIZATION_OWNER: 'organization_owner',
  PLATFORM_PAYMENT_MANAGER: 'platform_payment_manager',
  PLATFORM_MEMBER: 'platform_member',
  VETTING_MEMBER: 'vetting_member',
  VETTING_REVIEWER: 'vetting_reviewer',
  CONTENT_STUDIO_MEMBER: 'content_studio_member',
};

export type Role = (typeof ROLES)[keyof typeof ROLES];

export default ROLES;
